import { render, staticRenderFns } from "./packaging_items.vue?vue&type=template&id=1a4cf524"
import script from "./packaging_items.vue?vue&type=script&lang=js"
export * from "./packaging_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports